<!DOCTYPE html>
<html>
    <head>
		<title>TypeScript Greeter</title>
		<meta charset="utf-8">
    </head>
    <body>
			<div class="center">
				<div class="margin">
					<div class="container1">
						<div class="border">
						<img src="../assets/latvia.png" alt="Latviski">
						Karšu pārlūkā ievietotās kartes ir sagatavotas, izmantojot automatizētus datorizētus risinājumus, kas izstrādāti Ventspils Augstskolas Inženierzinātņu institūta „Ventspils Starptautiskais radioastronomijas centrs” Tālizpētes nodaļas pētījumu rezultātā.

						Pārlūks izstrādāts mācību nolūkiem, un, cerams, kādam tas būs noderīgs, taču šis karšu pārlūks vēl ir izstrādes stadijā, tādēļ tajā iespējamas kļūdas.

						Karšu licence: Creative Commons License Attribution-NonCommercial-NoDerivs 2.0 Generic (CC BY-NC-ND 2.0).

						Kartes ir eksperimentāli produkti un tādēļ uz tām NAV ATTIECINĀMA NEKĀDA VEIDA GARANTIJA, tai skaitā arī piemērotība noteiktam mērķim. Tā kā uz kartēm nav attiecināma garantija, tad šo karšu autors neuzņemas nekādu atbildību par sekām, kas var rasties pirms vai pēc šīs datu kopas lietošanas un datu kopas lietošanas laikā.
						</div>
					</div>
				</div>
				<div class="margin">
					<div class="container2">
						<div class="border">
						<img src="../assets/uk.png" alt="Latviski">
						Maps shown in this browser are automatically prepared by computerized methods during the research by Remote Sensing department of Ventspils Univerity’s of Applied Sciences engineering research institute “Ventspils International Radioastronomy Centre” (VIRAC).

						The map browser is developed for educational purposes and hopefully will be somehow useful, although it is still in development phase thus there still might be some problems.

						Maps are licensed under Creative Commons License Attribution-NonCommercial-NoDerivs 2.0 Generic (CC BY-NC-ND 2.0).

						These maps are experimental products and therefore comes WITHOUT ANY WARRANTY; without even the FITNESS FOR A PARTICULAR PURPOSE.

						As this data set comes WITHOUT ANY WARRANTY author of these maps is not liable about any consequences which may be caused before, during or after use of this data set.
						</div>
					</div>
				</div>
			</div>
    </body>
</html>
